<template>
  <section>
    <img
      :class="[
        isSheet ? 'sheet-animation-gif-size' : 'pass-animation-gif-size',
        { 'is-stamprally': isStampRally },
      ]"
      class="sheet-animation-gif-size"
      :src="url"
    />
  </section>
</template>

<script>
import nativeHandlerService from "@/services/nativeHandler";
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";

export default {
  name: "FaceAnimation",
  props: {
    url: {
      type: String,
      required: false,
      default: null,
    },
    isSheet: {
      type: Boolean,
      required: false,
      default: false,
    },
    isStampRally: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    const masterSheet = computed(() => store.getters["ticketing/masterSheet"]);
    const masterPass = computed(() => store.getters["ticketing/masterPass"]);
    const store = useStore();

    onMounted(async () => {
      if (props.isSheet) {
        await nativeHandlerService.ncMyTicketStartAnimation(
          "sheet",
          masterSheet.value.id
        );
      } else {
        await nativeHandlerService.ncMyTicketStartAnimation(
          "pass",
          masterPass.value.id
        );
      }
    });
  },
};
</script>

<style lang="scss">
.sheet-animation-gif-size {
  width: 60%;
  display: block;
  margin: 40px auto 80px;
}
.pass-animation-gif-size {
  width: 100%;
  margin: 0px auto 10px;

  @media screen and (min-height: 760px) {
    margin: 0px auto 20px;
  }
}
.is-stamprally {
  padding-bottom: 80px;
}
</style>
